<template>
  <div>
    <span class="caption font-weight-bold mb-0"> {{ label }}: </span>
    <vue-image-upload
      v-if="showDialog"
      v-model="picture"
      profile
      @close="showDialog = false"
    ></vue-image-upload>
    <div v-if="picture" class="text-center">
      <v-hover>
        <v-img
          slot-scope="{ hover }"
          :src="picture"
          style="height: 80px; width: 80px; border:2px solid #efefef;"
        >
          <v-expand-transition>
            <div
              v-if="hover"
              class="pointer d-flex transition-fast-in-fast-out display-3 white--text"
              @click="(picture = ''), (showDialog = false)"
            >
              <v-icon size="24" v-text="$getIcon('mdiClose')"></v-icon>
            </div>
          </v-expand-transition>
        </v-img>
      </v-hover>
    </div>
    <v-responsive
      v-else
      style="height: 80px; width: 80px;"
      class="pa-1 ma-1 grey lighten-3 pointer"
      @click="showDialog = true"
    >
      <v-row class="" justify="center" align="center">
        <v-col cols="12" class="pb-0 px-0 text-center">
          <v-icon
            color="grey"
            size="30"
            v-text="$getIcon('mdiUpload')"
          ></v-icon>
        </v-col>
        <v-col
          class="text-center caption grey--text py-0"
          v-text="'Image'"
        ></v-col>
      </v-row>
    </v-responsive>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Profile Picture"
    }
  },
  data() {
    return {
      showDialog: false,
      picture: this.value
    };
  },
  watch: {
    picture: {
      handler(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
